<ng-container *transloco="let t">
  <mat-toolbar class="tool-bar">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center">
      <h1>{{ t("role.assignUser") }}</h1>
      <span class="example-spacer"></span>
      <mat-icon mat-dialog-close>close</mat-icon>
    </mat-toolbar-row>
  </mat-toolbar>
  <form [formGroup]="assignUserForm" (ngSubmit)="submit()">
    <mat-dialog-content class="mat-typography">
      <div fxLayout="row wrap" class="padding-top-bottom-10">
        <div fxFlex="100">
          <mat-chip-set aria-label="User selection">
            <mat-chip *ngFor="let user of userInRoles"
              (removed)="removeUser(user)"
              >{{ user?.userName }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-set>
        </div>
        <div fxFlex="100" class="padding-top-bottom-10">
          <mat-form-field class="example-full-width">
            <mat-error *ngIf="myControl?.errors?.['required']">{{
              t("role.selectUser")
            }}</mat-error>
            <mat-error *ngIf="myControl?.errors?.['forbiddenNames']">{{
              t("role.selectProperUser")
            }}</mat-error>
            <input
              type="text"
              matInput
              [matAutocomplete]="auto"
              formControlName="myControl"
            />
          </mat-form-field>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option
              *ngFor="let user of filteredOptions | async"
              [value]="user"
            >
              {{ user.userName }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
    </mat-dialog-content>
    <div fxLayout="row" class="dialog-actions">
      <button
        type="submit"
        mat-flat-button
        color="primary"
        [disabled]="assignUserForm.invalid"
      >
        ASSIGN
      </button>
      <button
        mat-stroked-button
        class="margin-left-right-10"
        (click)="onClose()"
      >
        CANCEL
      </button>
    </div>
  </form>
</ng-container>
